import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withKeys as _withKeys, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/image-upload.svg'


const _withScopeId = (n: any) => (_pushScopeId("data-v-6e3a4949"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "button-inner"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "Upload an image",
  class: "image-uploader-svg"
}, null, -1))
const _hoisted_3 = {
  key: 1,
  class: "button-inner"
}
const _hoisted_4 = { class: "team-image-container-sq" }
const _hoisted_5 = ["src"]

import { ref } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'image-uploader',
  props: {
    isActive: { type: Boolean }
  },
  emits: ["file-uploaded", "tile-selected"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const imageSrc = ref<string | null>(null);
const fileInput = ref<HTMLInputElement | null>(null);

const emit = __emit;

const triggerFileInput = () => {
  fileInput.value?.click();
};

const handleTileClick = () => {
  if (!imageSrc.value) {
    triggerFileInput();
  } else {
    emit("tile-selected", imageSrc.value);
  }
};

// Handle file selection and display the image
const handleFileChange = () => {
  if (fileInput.value?.files && fileInput.value.files.length > 0) {
    const selectedFile = fileInput.value.files[0];

    // Use FileReader to get the data URL of the selected image
    const reader = new FileReader();
    reader.onload = (event) => {
      imageSrc.value = event.target?.result as string;
    };
    reader.readAsDataURL(selectedFile);
    emit("file-uploaded", selectedFile);
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    class: _normalizeClass(["image-uploader-button btn btn-default", { active: props.isActive }]),
    "data-test": "team-image-upload-button",
    onClick: handleTileClick
  }, [
    _createElementVNode("input", {
      type: "file",
      "aria-label": "Upload an image",
      ref_key: "fileInput",
      ref: fileInput,
      style: {"display":"none"},
      accept: "image/png, image/jpeg",
      onChange: handleFileChange,
      "data-test": "image-upload-input"
    }, null, 544),
    (!imageSrc.value)
      ? (_openBlock(), _createElementBlock("span", _hoisted_1, [
          _hoisted_2,
          _createTextVNode(" Images up to 4MB ")
        ]))
      : (_openBlock(), _createElementBlock("span", _hoisted_3, [
          _createElementVNode("span", _hoisted_4, [
            _createElementVNode("img", {
              src: imageSrc.value,
              alt: "Selected image",
              class: "image-uploader-svg",
              "data-test": "uploaded-image"
            }, null, 8, _hoisted_5)
          ]),
          _createElementVNode("img", {
            src: _imports_0,
            alt: "Upload an image",
            class: "image-uploader-sm-icon",
            tabindex: "0",
            onClick: triggerFileInput,
            onKeydown: _withKeys(triggerFileInput, ["enter"])
          }, null, 32)
        ]))
  ], 2))
}
}

})